
/**
 * Use of setTimeout instead of setInterval
 * @private
 * comment : won't use Symbol() and load @babel/polyfill
 */
const _ = {
    runningInterval () {
        const diff = new Date().getTime() - this._timer['stop'];
        let timeout = this._timer['interval'] - ((new Date().getTime() - this._timer['start']) % this._timer['interval']);

        if (diff >= this._timer['interval']) {
            this.next();
        } else {
            timeout = this._timer['interval'] - diff;
        }

        if (this._timer['id'] !== 0) {
            clearTimeout(this._timer['id']);
        }

        this._timer['id'] = setTimeout(_.runningInterval.bind(this), timeout);
    },

    onMediaQueriesChange () {
        const changeFocusX = (matches) => {
            this._slides.forEach((el) => {
                if (el.hasAttribute("data-focus-x")) {
                    el.setAttribute("data-focus-x", (matches ? "0.00" : el.focusXValue));
                }
            });
        },
        storeIntialAttributeValue = () => {
            this._slides.forEach((el) => {
                if (el.hasAttribute("data-focus-x")) {
                    el.focusXValue = el.getAttribute("data-focus-x");
                }
            });
        };

        // media query event handler : used to set image position
        if (matchMedia) {
            const mediaQueries = window.matchMedia("(min-width: 769px)");
            storeIntialAttributeValue();

            mediaQueries.addListener((mq) => {
                changeFocusX(mq.matches);
            });

            // on load
            changeFocusX(mediaQueries.matches);
        }
    },

    isLocked : false,

    addLock () {
        _.isLocked = true;
    },

    removeLock () {
        _.isLocked = false;
    }
};

/**
 * Use only switch of css classes
 * Works on opacity and transition effect
 *
 * O-Slider
 * O-Slider__Item
 * O-Slider__Item--show
 */
class Slider {

    constructor (elementSelector, options = {interval: 6000}) {
        this._elementSelector = Slider.getSelectorName(elementSelector);
        this._element = document.querySelector(elementSelector);
        this._itemClassName = this._elementSelector + '__Item';
        this._slides = document.querySelectorAll('.' + this._elementSelector + '__Item');
        this._current = 0;
        this._timer = {
            start : new Date().getTime(), stop : new Date().getTime(), id : 0,
            interval : options.interval < 3000 ? 3000 : options.interval
        };

        if (!this._slides.length) {
            throw Error('Slide Item should be build from "wrapperClassName + \'__Item\'"');
        }

        // attach
        _.onMediaQueriesChange.call(this);

        // window.onblur = this.pause.bind(this);
        // window.onfocus = this.play.bind(this);
    }

    play (removeLock = false) {
        removeLock && _.removeLock();

        if (!_.isLocked) {
            _.runningInterval.call(this);
        }
    }

    pause (addLock = false) {
        const id = this._timer['id'];

        clearTimeout(id);
        this._timer['stop'] = new Date().getTime();
        addLock && _.addLock();
    }

    next () {
        let current = this._current;
        this._slides[current].classList.remove(this._itemClassName + '--show');
        this._current = current = (current + 1) % this._slides.length;
        this._slides[current].classList.add(this._itemClassName + '--show');
    };

    getElement () {
        return this._element;
    }

    static getSelectorName (selector) {
        return selector.substring(1, selector.length);
    };
}

export default Slider;